/*
   require.context函数(directory,useSubdirectories,regExep)
   # directory { string } - 读取文件路径
   # useSubdirectories { Boolean } - 是否遍历子目录
   # regExp { regExt } - 匹配文件的正则
   返回值是一个函数，并且这个函数有keys个属性
   # keys { function } - 匹配成功模块的名字组成的数组
*/
const importFn = require.context('./', true, /index\.vue$/);

export default {
  install (app) {
    importFn.keys().forEach(path => {
      const component = importFn(path).default
      // console.log(component)
      app.component(component.name, component)
    })
  }
}
